// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/heros/hero-image_4.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 650px) {
  .app-bar {
    grid-template-columns: 1fr auto;
    padding: 8px 32px;
  }

  .app-bar .app-bar__brand h1 {
    font-size: 1.5em;
  }

  .app-bar .app-bar__menu {
    display: none;
  }

  .app-bar .app-bar__navigation {
    position: static;
    width: 100%;
  }

  .app-bar .app-bar__navigation ul li {
    display: inline-block;
  }

  .app-bar .app-bar__navigation ul li a {
    display: inline-block;
    width: 120px;
    text-align: center;
    margin: 0;
  }
  .skip2content {
    display: none;
  }
  

  .hero-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  .hero-container .hero-content-container {
    text-align: left;
    line-height: 1.5em;
  }
}

@media screen and (min-width: 800px) {
  .app-bar .app-bar__brand h1 {
    font-size: 2em;
  }
  section {
    margin-bottom: 80px;
  }

  .main-resto_label {
    font-size: 26px;
  }

  .list-resto {
    grid-template-columns: 1fr 1fr;
  }
  .detail-review {
    grid-template-columns: 1fr 1fr;
  }

  .resto-item_name {
    font-size: 22px;
  }
  .main-resto_container {
    padding: 0 30px;
  }
  .restaurant-detail__menu-list {
    margin-bottom: 5px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 50px;
    max-width: 750px;
    margin: 0 auto;
  }
  
}

@media screen and (min-width: 1200px) {
  .app-bar {
    padding: 0 100px;
  }
  .list-resto {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .detail-review {
    grid-template-columns: 1fr 1fr 1fr;
  }
  
  .container-info {
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    grid-gap: 1.5em;
    margin-top: 1em;
  }
}

@media only screen and (max-width: 768px) {
  .restaurant-detail__info,
  .restaurant-detail__menu-list,
  .restaurant-detail__review {
    margin-bottom: 5px;
    display: grid;
    grid-template-columns: repeat(1, minmax(300px, 1fr));
    gap: 50px;
    margin: 0 auto;
  }
  .detail-review {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .resto-item_image-container {
    max-width: 300px;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,aAAa;EACf;;;EAGA;IACE,yDAAgE;EAClE;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;IAChB,cAAc;EAChB;;AAEF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,kBAAkB;IAClB,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;;AAEF","sourcesContent":["@media screen and (min-width: 650px) {\r\n  .app-bar {\r\n    grid-template-columns: 1fr auto;\r\n    padding: 8px 32px;\r\n  }\r\n\r\n  .app-bar .app-bar__brand h1 {\r\n    font-size: 1.5em;\r\n  }\r\n\r\n  .app-bar .app-bar__menu {\r\n    display: none;\r\n  }\r\n\r\n  .app-bar .app-bar__navigation {\r\n    position: static;\r\n    width: 100%;\r\n  }\r\n\r\n  .app-bar .app-bar__navigation ul li {\r\n    display: inline-block;\r\n  }\r\n\r\n  .app-bar .app-bar__navigation ul li a {\r\n    display: inline-block;\r\n    width: 120px;\r\n    text-align: center;\r\n    margin: 0;\r\n  }\r\n  .skip2content {\r\n    display: none;\r\n  }\r\n  \r\n\r\n  .hero-container {\r\n    background-image: url(\"../public/images/heros/hero-image_4.jpg\");\r\n  }\r\n\r\n  .hero-container .hero-content-container {\r\n    text-align: left;\r\n    line-height: 1.5em;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 800px) {\r\n  .app-bar .app-bar__brand h1 {\r\n    font-size: 2em;\r\n  }\r\n  section {\r\n    margin-bottom: 80px;\r\n  }\r\n\r\n  .main-resto_label {\r\n    font-size: 26px;\r\n  }\r\n\r\n  .list-resto {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n  .detail-review {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .resto-item_name {\r\n    font-size: 22px;\r\n  }\r\n  .main-resto_container {\r\n    padding: 0 30px;\r\n  }\r\n  .restaurant-detail__menu-list {\r\n    margin-bottom: 5px;\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n    gap: 50px;\r\n    max-width: 750px;\r\n    margin: 0 auto;\r\n  }\r\n  \r\n}\r\n\r\n@media screen and (min-width: 1200px) {\r\n  .app-bar {\r\n    padding: 0 100px;\r\n  }\r\n  .list-resto {\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n  }\r\n\r\n  .detail-review {\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n  }\r\n  \r\n  .container-info {\r\n    display: grid;\r\n    grid-template-columns: 1.5fr 1fr;\r\n    grid-gap: 1.5em;\r\n    margin-top: 1em;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  .restaurant-detail__info,\r\n  .restaurant-detail__menu-list,\r\n  .restaurant-detail__review {\r\n    margin-bottom: 5px;\r\n    display: grid;\r\n    grid-template-columns: repeat(1, minmax(300px, 1fr));\r\n    gap: 50px;\r\n    margin: 0 auto;\r\n  }\r\n  .detail-review {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 20px;\r\n  }\r\n  .resto-item_image-container {\r\n    max-width: 300px;\r\n  }\r\n  \r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
